import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../../components/Layout";
import Container from "../../../components/Container";
import Flex from "../../../components/Flex";
import { Link, useParams } from "react-router-dom";
import Content from "../../../components/Content";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { requiresClient } from "../../../components/AuthProvider";
import DropDownList from "../../../components/DropDownList";
import TaskTypes from "../taskTypes";
import Spinner from "../../../components/Loader/Spinner";
import MatchingTask from "./matchingTask";
import DataExtractionTask from "./dataExtractionTask";
import styles from "./StartRerunTask.module.scss";

const StartRerunTask = () => {
  // TODO this functionality has been unused and is deprecated
  const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_V1_DOMAIN;
  const batchLoadsRpcUrl = `${clientConfigApiDomain}/rpc/batchloads`;

  const { taskId } = useParams();

  const [taskData, setTaskData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [selectedTaskValue, setSelectedTaskValue] = useState("0");

  const handleChange = event => {
    setSelectedTaskValue(event.target.value);
  };

  let loadedBreadcrumbs = (
    <Breadcrumbs>
      <Breadcrumbs.Item render={() => <Link to="/">Home</Link>} />
      <Breadcrumbs.Item render={() => <Link to="/tasks">Tasks</Link>} />
      {taskId ? (
        <>
          <Breadcrumbs.Item
            render={() => (
              <Link to={`/tasks/${taskId}`}>Batch Load: {taskId}</Link>
            )}
          />
          <Breadcrumbs.Item last render={() => "Rerun"}></Breadcrumbs.Item>
        </>
      ) : (
        <Breadcrumbs.Item last render={() => `Start`} />
      )}
    </Breadcrumbs>
  );

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    const response = await fetch(`${batchLoadsRpcUrl}/${taskId}/`);
    const data = await response.json();
    setTaskData(data);
    setSelectedTaskValue(data.task_name);
    setIsLoading(false);
    setHasLoaded(true);
  }, [taskId, batchLoadsRpcUrl]);

  useEffect(() => {
    if (!hasLoaded && taskId !== undefined) {
      fetchData();
    } else {
      // this enables the add screen to show up
      setHasLoaded(true);
    }
  }, [taskId, hasLoaded, fetchData, selectedTaskValue]);

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          <Flex.Item span={12}>{loadedBreadcrumbs}</Flex.Item>
          <Flex.Item span={12}>
            {isLoading ? (
              <Spinner />
            ) : (
              <>
                <Content>
                  {taskId ? <h1>Rerun Task: {taskId}</h1> : <h1>Start Task</h1>}
                </Content>

                <div className={styles.base}>
                  <div className={styles.detailsFlex}>
                    <h3>Task Type</h3>
                  </div>
                  <div className={styles.details}>
                    {taskId ? (
                      TaskTypes[taskData.task_name]
                    ) : (
                      <DropDownList
                        id="taskType"
                        onChange={handleChange}
                        required
                        width="33%"
                      >
                        <DropDownList.Item key="Select Task Type" value="0">
                          Select Task Type
                        </DropDownList.Item>
                        <DropDownList.Item
                          key="Patient Matching"
                          value="Patient Matching"
                        >
                          Matching
                        </DropDownList.Item>
                        <DropDownList.Item
                          key="Data Extraction"
                          value="data-extraction"
                        >
                          Data Extraction
                        </DropDownList.Item>
                      </DropDownList>
                    )}
                  </div>
                </div>
              </>
            )}
          </Flex.Item>
          {selectedTaskValue === "Patient Matching" && (
            <MatchingTask taskData={taskData} />
          )}
          {selectedTaskValue === "data-extraction" && (
            <DataExtractionTask taskData={taskData} />
          )}
          {selectedTaskValue === "repartition-identities" && (
            <p>This task has not been setup for rerun.</p>
          )}
        </Flex>
      </Container>
    </Layout>
  );
};

export default requiresClient(StartRerunTask);
